module.exports = __webpack_public_path__ + "static/media/ecosystem_content.905202cc.png";